<template>
<v-card v-bind='attrs' :dark='dark' flat >
  <v-card-title class="pb-2 overline" >
    <v-icon v-if='withIcon' small class='mr-2'>filter_list</v-icon>
    <span v-if='initialRelationship && initialRelationship.client' >
      {{initialRelationship.client.first_name}}
      {{initialRelationship.client.last_name}}
    </span>
    <span v-else v-text='title' />
    <v-spacer></v-spacer>

    <v-btn icon small
      v-if='withClose' @click='$emit("close")' >
      <v-icon>close</v-icon>
    </v-btn>
    <v-chip
      v-if='numResults'
      class='mr-0 v-chip--x-small' color='primary' outline >{{numResults}}
    </v-chip>

    <template v-if='withThemeToggle' >
      <v-icon @click='dark=false' small v-if='dark' >light_mode</v-icon>
      <v-icon @click='dark=true' small v-else >dark_mode</v-icon>
    </template>

  </v-card-title>
  <v-divider></v-divider>

  <!-- <v-layout>
    <v-flex><v-text-field v-model='filters.dateRange.from' prepend-icon='event' @click='datepickervisible=true' readonly label='from date' class='ml-1' ></v-text-field></v-flex>
    <v-flex><v-text-field v-model='filters.dateRange.to'  prepend-icon='event' @click='datepickervisible=true' readonly label='to date' class='mr-1' ></v-text-field></v-flex>
  </v-layout> -->
  <v-list dense subheader class='pa-0' >
    <v-subheader class="py-0 overline" >
      Choose a date range
      <v-spacer />

      <template v-if='!requireDaterange' >
        <v-chip v-if='disableDate'
          @click='disableDate=false'
          class='mr-0 v-chip--x-small' icon small outline >
          Apply
          <v-icon right small >timer</v-icon>
        </v-chip>
        <v-chip v-else
          @click='disableDate=true'
          class='mr-0 v-chip--x-small' icon small outline >
          Clear
          <v-icon small >timer_off</v-icon>
        </v-chip>
      </template>
    </v-subheader>
    <v-list-tile :disabled='disableDate' @click='datepickervisible=true' >
      <v-list-tile-action >
        <v-icon >event</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          {{dateformat(dateRange.from)}} - {{dateformat(dateRange.to)}}
        </v-list-tile-title>
        <v-list-tile-sub-title>
          Click to change dates
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
  <date-range-picker with-ok with-close
    @close='datepickervisible=false' class='mt-0 pt-0'
    v-if='datepickervisible' transition="scroll-y-transition"
    v-model='dateRange' >
  </date-range-picker>

  <!-- <v-divider class='mt-4 my-2'></v-divider>
  <v-subheader class='overline py-0 mb-0' >Quick views</v-subheader>
  <v-select persistent-hint clearable dense dark return-object
    :items='views'
    v-model='selectedView'
    item-text='title'
    label='Views'
    hint='A selection of useful pre-prepared filters'
    class=mx-3 >
  </v-select> -->
  <!-- !relationship &&  -->
  <v-divider class='mt-4 my-2'></v-divider>
  <slot name='relationship-picker' >
    <relationship-picker with-quick-pick
      v-if='dateRange.from && !initialRelationship'
      class='mx-3'
      v-model='selectedRelationships'
      :multiple='multipleRelationships'
      :practitioner-id='practitionerId'
      :statuses='relationshipStatuses'
      :from-date="dateRange.from"
      :to-date="dateRange.to"
      :touch="touch"
      @count='setCount' >
    </relationship-picker >
  </slot>

  <template v-if='!mini && dateRange.from && dateRange.to' >

    <template v-if='facets && facets.practitioner' >
      <v-subheader class='overline' >
        Practitioner
        <v-spacer/>
        <v-chip
          @click='selectedPractitioners=[]'
          v-if='selectedPractitioners > 0' outline class='v-chip--x-small' >clear</v-chip>
      </v-subheader>
      <template v-for='data, pk in getColleagues' >
        <v-checkbox hide-details dense
          class='pa-0 ma-0 ml-2'
          v-model='selectedPractitioners'
          :key='pk'
          :value='pk'
          :color='data.color'
          :label='getPractitionerLabel(data, facets.practitioner)' />
      </template>
    </template>
      <!-- <pre v-text='getColleagues' /> -->

    <v-subheader class='overline' >Status
      <v-spacer/>
      <v-chip
        @click='selectedStatuses=[]'
        v-if='selectedStatuses > 0' outline class='v-chip--x-small' >clear</v-chip>
    </v-subheader>
    <template v-for='(data, code) in statuses' >
      <v-checkbox hide-details dense
        class='pa-0 ma-0 ml-2'
        v-model='selectedStatuses'
        :key='code'
        :value='code'
        :color='data.theme'
        :label='getStatusLabel(code, data, facets.status)' />
    </template>

    <template v-if='facets && facets.space' >
      <v-subheader class='overline' >Space
        <v-spacer/>
        <v-chip
          @click='selectedSpaces=[]'
          v-if='selectedSpaces > 0' outline class='v-chip--x-small' >clear</v-chip>
      </v-subheader>
      <template v-for='space in spaces' >
        <v-checkbox hide-details dense
          class='pa-0 ma-0 ml-2'
          v-model='selectedSpaces'
          :key='space.id'
          :value='space.id'
          :color='space.color'
          :label='getSpaceLabel(space, facets.space)' />
      </template>
    </template>

    <template>
      <v-subheader class='overline' >Codes
        <v-spacer/>
        <v-chip outline
          @click='hasCodes=null'
          class='v-chip--x-small' >clear</v-chip>
      </v-subheader>
      <v-radio-group v-model="hasCodes" class='pa-0 ma-0 ml-2' >
        <v-radio value='yes' label='Have ICD-10 codes' />
        <v-radio value='no' label='Without ICD-10 codes' />
      </v-radio-group>
    </template>
    <!-- <status-picker v-model='selectedStatuses' >
    </status-picker> -->

  </template>

  <slot name='actions' >
  </slot>

  <template >
    <v-subheader class='overline' >Results per page</v-subheader>
    <v-layout class='mb-4' >
      <v-spacer/>
      <v-flex v-for='size in pageSizes' :key='size' >
        <v-checkbox hide-details dense
          class='pa-0 ma-0'
          v-model='selectedPageSize'
          :key='size'
          :value='size'
          :label="`${size.toString()}`" />
      </v-flex>
      <v-spacer/>
    </v-layout>
  </template>
  <!-- <pre v-text='filters' /> -->
  <!-- <v-card-actions >
    <v-btn @click='fetch' :loading='request.loading' block color='primary' >Apply filters</v-btn>
  </v-card-actions> -->
</v-card>
</template>
<script>
import RelationshipPicker from '@/components/pickers/RelationshipPicker'
// import FacetField from '@/components/filters/FacetField.vue'
import StatusPicker from '@/components/pickers/StatusPicker'
import DateRangePicker from '@/components/pickers/DateRangePicker'
import {DateTime} from 'luxon'
import {mapGetters} from 'vuex'
import {STATUSES} from '@/store/constants'
export default {
  name: 'AppointmentFilter',
  components: {
    RelationshipPicker,
    DateRangePicker,
    StatusPicker
    // FacetField
  },
  props: {
    // value: { type: Object },
    title: { type: String, default: 'Filters' },
    facets: { type: Object },
    numResults: { type: Number },
    pageSize: { type: Number, default: 20 },
    touch: { type: Number, default: 0 },
    practitionerId: {type: Number},
    relationship: {type: Object},
    initialRelationship: {type: Object},
    relationshipStatuses: { type: Array, default: () => { return [] } },
    multipleRelationships: { type: Boolean, default: true },
    attrs: { type: Object, default: () => {} },
    withIcon: { type: Boolean, default: true },
    requireDaterange: { type: Boolean, default: false },
    clearDateRange: { type: Boolean, default: false },
    mini: { type: Boolean, default: false },
    withClose: { type: Boolean, default: false },
    withThemeToggle: { type: Boolean, default: false }
  },
  data () {
    return {
      datepickervisible: false,
      selectedView: null,
      selectedPractitioners: [],
      selectedRelationships: [],
      selectedSpaces: [],
      selectedStatuses: [],
      selectedPageSize: 20,
      pageSizes: [5, 10, 20, 30, 40, 50],
      // dateRange: { from: null, to: null },
      disableDate: false,
      hasCodes: null,
      statuses: STATUSES,
      dark: false
    }
  },
  mounted () {
    // if (this.value) { this.filters = this.value }
    this.selectedPageSize = this.pageSize
    this.reset()
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        this.$emit('input', this.filters)
      }
    },
    selectedRelationships () {
      if (!this.multipleRelationships) {
        this.$emit('update:relationship', this.selectedRelationships)
      }
    },
    touch () {
      this.reset()
    },
    pageSize () {
      if (this.pageSize) {
        this.selectedPageSize = this.pageSize
      }
    },
    selectedPageSize () {
      if (this.selectedPageSize) {
        this.$emit('update:pageSize', parseInt(this.selectedPageSize))
      }
    }
  },
  methods: {
    getPractitionerLabel (practitioner, facet) {
      let count = '0'
      let pk = practitioner.id
      if (facet && (pk in facet)) { count = facet[pk] }
      if (practitioner && practitioner.id) {
        return `${practitioner.full_name} (${count})`
      }
      return `Not set (${count})`
    },
    getSpaceLabel (space, facet) {
      let count = '0'
      let pk = space.id
      if (facet && (pk in facet)) { count = facet[pk] }
      if (space && space.title) {
        return `${space.title} (${count})`
      }
      return `Not set (${count})`
    },
    getStatusLabel (code, data, facet) {
      let title = data.title
      let count = '0'
      if (facet && (code in facet)) {
        count = facet[code]
      }
      return `${title} (${count})`
    },
    setCount (cnt) {
      this.$emit('count', cnt)
    },
    reset () {
      if (this.clearDateRange === true) {
        this.disableDate = true
      }
      let today = DateTime.local()
      if (!this.dateRange.from) {
        if (this.activeDateRange && this.activeDateRange.from) {
          this.dateRange.from = this.activeDateRange.from
        } else {
          this.dateRange.from = today.startOf('month').toISODate()
        }
      }
      if (!this.dateRange.to) {
        if (this.activeDateRange && this.activeDateRange.to) {
          this.dateRange.to = this.activeDateRange.to
        } else {
          this.dateRange.to = today.endOf('month').toISODate()
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getPractitionerById', 'getSpaceById', 'getColleagues', 'spaces', 'activeDateRange']),
    relationshipId () {
      if (this.relationship && this.relationship.id) { return this.relationship.id }
      return null
    },
    dateRange: {
      get () {
        return this.activeDateRange
      },
      set (val) {
        if (val.to && val.from) {
          this.$store.commit('SET_ACTIVE_DATE_RANGE', [val.from, val.to])
        }
      }
    },
    filters () {
      let data = {}
      if (this.selectedView) {
        data = this.selectedView.params
      }
      if (this.disableDate !== true) {
        if (this.dateRange.from) { data['after_utc'] = this.dateRange.from }
        if (this.dateRange.to) { data['before_utc'] = this.dateRange.to }
      }
      if (this.selectedPractitioners && this.selectedPractitioners.length > 0) {
        data['practitioner_id-in'] = this.selectedPractitioners.join(',')
      }
      if (this.selectedStatuses && this.selectedStatuses.length > 0) {
        data.statuses = this.selectedStatuses
      }
      if (this.selectedSpaces && this.selectedSpaces.length > 0) {
        data['space_id-in'] = this.selectedSpaces.join(',')
      }
      if (this.selectedRelationships && this.selectedRelationships.length > 0) {
        let relIds = this.selectedRelationships.map((rel) => { return rel.id }).join(',')
        data['relationships-in'] = relIds
      }
      if (this.practitionerId) {
        data['practitioner_id'] = this.practitionerId
      }
      if (this.relationshipId) {
        data['relationships'] = this.relationshipId
      }
      if (this.hasCodes !== null) {
        data['has-codes'] = this.hasCodes
      }
      if (this.selectedPageSize) {
        data['page_size'] = this.selectedPageSize
      }
      // data['page_size'] = 40
      this.$emit('input', data)
      return data
    },
    views () {
      return [
        {
          title: 'Invoiceable',
          subtitle: 'Appointments which have not yet been invoiced',
          params: {
            statuses: ['N', 'C']
          }
        },
        {
          title: 'Invoiced but not paid',
          subtitle: 'Appointments which have been invoiced, but not yet been paid',
          params: {

          }
        },
        {
          title: 'Marked ready for invoicing',
          subtitle: 'Appointment which have explicitly been marked as ready to invoice',
          params: {}
        },
        {
          title: 'Not marked ready for invoicing',
          subtitle: 'vice versa',
          params: {}
        },
        {
          title: 'Needs coding',
          subtitle: 'Appointments which do not have ICD-10 codes',
          params: {}
        },
        {
          title: 'Cancelled appointments',
          subtitle: 'Appointments which have been cancelled'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// AppointmentFilters.vue?27258095